import { Component, OnInit, ViewChild } from '@angular/core';
import { UserFormComponent } from 'app/components/user-form/user-form.component';
import { User } from 'app/components/user-form/user.model';
import { SystemService } from 'app/services/system.service';
import { Entity } from '../../product/product.model';
import { ProductsService } from '../../products/products.service';
import {EntityListComponent} from '../../../components/entity-list/entity-list.component';

@Component({
    selector: 'app-user-page',
    templateUrl: './user-page.component.html',
    styleUrls: ['./user-page.component.scss']
})
export class UserPageComponent implements OnInit {

    allUsers: Entity[];
    user: User;

    @ViewChild('userForm')
    userForm: UserFormComponent;

    @ViewChild('entityList')
    entityList: EntityListComponent;

    listTitle: string;

    constructor(public _systemService: SystemService) {

    }

    selected(entity): void{
        this.user = entity;
        this.userForm.selected(entity);
    }

    ngOnInit(): void {
        this.allUsers = this._systemService.allUsers;
        this.listTitle = 'Lista de usuarios ' + '(' + this._systemService.users.length + ' / ' + this.allUsers.length + ')';
    }

    entityChanged(entity: any): void{
        if (typeof entity === 'number') {
            const activityIndex = this.allUsers.findIndex(elem => elem.id === entity);
            if (activityIndex !== -1) {
                this.allUsers.splice(activityIndex, 1);
            }
            this.selected(null);
        }else {
            const activityIndex = this.allUsers.findIndex(elem => elem.id === entity.id);
            if (activityIndex !== -1) {
                this.allUsers.splice(activityIndex, 1);
            }
            if (entity) {
                this.user = entity;
                this.allUsers.push(entity);
                this.allUsers.sort((a, b) => a.name > b.name ? 1 : -1);
                this.selected(this.user);
            } else {
                this.selected(null);
            }
        }
    }

    newUser(): void{
        this.user = new User();
        this.entityList.deselectAll();
        this.selected(this.user);
    }

}
